import { render, staticRenderFns } from "./shiftCell.vue?vue&type=template&id=0a50c8a9&"
import script from "./shiftCell.vue?vue&type=script&lang=ts&"
export * from "./shiftCell.vue?vue&type=script&lang=ts&"
import style0 from "./shiftCell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports